import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { CapsuleTabs } from "antd-mobile";
import PsContext from "../../context";
import {
  APP_TYPE,
  DB_POSTFIX,
  DENOMINATION,
  S3_BUCKET_HOME_PATH,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Card } from "react-bootstrap";

const TermsPrivacy = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  let params = useParams();
  const [activeTab, setActiveTab] = useState(null);
  const [terms, setTerms] = useState([]);
  useEffect(() => {
    if (APP_TYPE != "SAAS") loadTerms();
    /* console.log("S3_BUCKET_HOME_PATH is  defined", S3_BUCKET_HOME_PATH);
    console.log("App Type is  defined", APP_TYPE);
    console.log("DB Postfix is  defined", DB_POSTFIX);
    console.log("Denomination is  defined", DENOMINATION);*/
  }, []);

  //replace function
  const replacePlaceholders = (content) => {
    return content.replace(/{{(.*?)}}/g, (_, placeholder) => {
      const value = context.settingValue(placeholder.trim());
      return value !== undefined ? value : `{{${placeholder}}}`;
    });
  };
  const loadTerms = () => {
    context.setLoader(true);

    axios.post(ServiceUrl.LOGIN_V2.TERMS).then((res) => {
      if (res["data"].status == "1") {
        setTerms(res["data"].data);
        if (params.id) setActiveTab(params.id);
        else
          setActiveTab(
            res["data"].data.length > 0 ? res["data"].data[0].id : null
          );
      } else {
        Toast.show({
          content: res["data"].message || "Error",
          position: "top",
        });
      }
      context.setLoader(false);
    });
  };
  return (
    <>
      <Header
        title="Terms & Privacy Policy"
        backAction={[]}
        rightActions={[]}
        onBack={(e) => navigate("/")}
      />

      <div className="" data-aos="zoom-in">
        <div className="container-sm py-md-3 ">
          {activeTab && (
            <CapsuleTabs defaultActiveKey={activeTab}>
              {terms.map((item, index) => (
                <CapsuleTabs.Tab title={item.title} key={item.id}>
                  <Card>
                    <Card.Body>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: replacePlaceholders(item.content),
                        }}
                      />
                    </Card.Body>
                  </Card>
                </CapsuleTabs.Tab>
              ))}
            </CapsuleTabs>
          )}
        </div>
      </div>
    </>
  );
};
export default TermsPrivacy;
